import { render, staticRenderFns } from "./DnsRecordsPreview.vue?vue&type=template&id=8dd19396"
import script from "./DnsRecordsPreview.vue?vue&type=script&lang=js"
export * from "./DnsRecordsPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports